/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class TimeZoneService extends HttpHandlerService {

        constructor($http: ng.IHttpService) {
            super($http);
        }

        public getValidServerTimeZones(): ng.IPromise<Wars.Domain.Model.Dtos.TimeZoneDto[]> {
            var params: any = {};
            this.handlerUrl = "api/TimeZone/TimeZones";
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.TimeZoneDto[]) => {
                    return result;
                });
        }
    }
}

warsApp.registerService('TimeZoneService', ['$http']);